import LocalTime from "local-time";
export default (function () {
  LocalTime.start();
  LocalTime.config.i18n["nl"] = {
    date: {
      dayNames: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
      abbrDayNames: ["zo", "ma", "di", "wo", "do", "vr", "za"],
      monthNames: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december",
      ],
      abbrMonthNames: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
      yesterday: "gisteren",
      today: "vandaag",
      tomorrow: "morgen",
      on: "op {date}",
      formats: {
        default: "%b %e, %Y",
        thisYear: "%b %e",
      },
    },
    time: {
      am: "",
      pm: "",
      singular: "een {time}",
      singularAn: "een {time}",
      elapsed: "{time} geleden",
      second: "seconde",
      seconds: "seconden",
      minute: "minuut",
      minutes: "minuten",
      hour: "uur",
      hours: "uur",
      formats: {
        default: "%H:%M",
      },
    },
    datetime: {
      at: "{date} om {time}",
      formats: {
        default: "%e %B %Y om %H:%M %Z",
      },
    },
  };

  LocalTime.config.locale = document.documentElement.lang;
  LocalTime.config.defaultLocale = document.documentElement.lang;

  return LocalTime;
})();
